import { NavigationDrawerHeaderComponent, navigationDrawerHeaderTemplate } from './NavigationDrawerHeader';
import styles from './NavigationDrawerHeader.styles.scss';
export const navigationDrawerHeaderDefinition = {
    baseName: 'navigation-drawer-header',
    template: navigationDrawerHeaderTemplate,
    styles,
};
export const chameleonNavigationDrawerHeader = NavigationDrawerHeaderComponent.compose(navigationDrawerHeaderDefinition);
